import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useFacilityStartEndTime_facility$key } from "./__generated__/useFacilityStartEndTime_facility.graphql";

export const useFacilityStartEndTime = (
  facilityRef: useFacilityStartEndTime_facility$key | null
) => {
  const facility = useFragment(
    useFacilityStartEndTimeFragmentString,
    facilityRef
  );

  const startTime = facility?.startEndTime?.startTime || undefined;
  const endTime = facility?.startEndTime?.endTime || undefined;

  return {
    startTime,
    endTime,
  };
};

const useFacilityStartEndTimeFragmentString = graphql`
  fragment useFacilityStartEndTime_facility on Facility {
    startEndTime {
      startTime
      endTime
    }
  }
`;
